import api from './api';

export const callService = {
  // Initiate a call
  initiateCall: async (callData) => {
    try {
      const response = await api.post('/api/call_initiate', {
        conference_number: callData.conferenceNumber,
        customer_name: callData.customerName,
        passcode: callData.passcode,
        pincode: callData.pincode,
        quarter: callData.quarter,
        call_duration: callData.callDuration,
        is_recorded: callData.isRecorded || false,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get connection statistics
  getConnectionStats: async () => {
    try {
      const response = await api.get('/api/connection_stats');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Validate call data before submission
  validateCallData: (callData) => {
    const errors = {};

    // Validate conference number
    if (!callData.conferenceNumber) {
      errors.conferenceNumber = 'Conference number is required';
    } else if (!/^\+91\d{10}$/.test(callData.conferenceNumber)) {
      errors.conferenceNumber = 'Conference number must start with +91 and be 10 digits';
    }

    // Validate customer name
    if (!callData.customerName?.trim()) {
      errors.customerName = 'Customer name is required';
    }

    // Validate passcode
    if (!callData.passcode) {
      errors.passcode = 'Passcode is required';
    } else if (!/^\d{1,10}#$/.test(callData.passcode)) {
      errors.passcode = 'Passcode must be numeric, max 10 digits, and end with #';
    }

    // Validate pincode
    if (!callData.pincode) {
      errors.pincode = 'Pincode is required';
    } else if (!/^\d{1,10}#$/.test(callData.pincode)) {
      errors.pincode = 'Pincode must be numeric, max 10 digits, and end with #';
    }

    // Validate quarter
    const validQuarters = ['Q1', 'Q2', 'Q3', 'Q4'];
    if (!validQuarters.includes(callData.quarter?.toUpperCase())) {
      errors.quarter = 'Quarter must be Q1, Q2, Q3, or Q4';
    }

    // Validate call duration
    if (!callData.callDuration) {
      errors.callDuration = 'Call duration is required';
    } else if (!/^\d{2}:\d{2}:\d{2}$/.test(callData.callDuration)) {
      errors.callDuration = 'Call duration must be in HH:MM:SS format';
    } else {
      const [hours, minutes, seconds] = callData.callDuration.split(':').map(Number);
      if (hours > 23 || minutes > 59 || seconds > 59) {
        errors.callDuration = 'Invalid time values in HH:MM:SS format';
      } else {
        const totalSeconds = hours * 3600 + minutes * 60 + seconds;
        if (totalSeconds > 7200) { // 2 hours
          errors.callDuration = 'Call duration cannot exceed 2 hours (02:00:00)';
        }
      }
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors,
    };
  },
}; 